import React from 'react';
import Seo from '../components/Seo';
import KontaktSection from '../components/Kontakt';
import { AnimatedSection } from '../shared/ui';

const Kontakt: React.FC = () => (
  <>
    <Seo
      title="Kontakt & kostenlose Besichtigung | AP Clean Services"
      description="Fragen Sie eine kostenlose Besichtigung bei AP Clean Services in Bielefeld, Gütersloh und Umgebung an. Transparentes Festpreisangebot für Ihre Reinigung."
      path="/kontakt"
    />
    <AnimatedSection>
      <KontaktSection headingLevel="h1" />
    </AnimatedSection>
  </>
);

export default Kontakt;
